export const TOPIC_NAME = "LobsterAI";
export const BRAND_NAME = "LobsterAI";
export const BRAND_SLUG = "lobsterai";
export const BRAND_TAGLINE =
  "Independent guide to LobsterAI, Cowork mode, and agent-native productivity";
export const VISIBLE_LOGO_SRC = "/imgs/logos/logo.svg";
export const PRIMARY_DOMAIN = "lobsterai.homes";
export const PRIMARY_URL = `https://${PRIMARY_DOMAIN}`;
export const OPERATOR_NAME = "lobsterai.homes";
export const OPERATOR_URL = PRIMARY_URL;
export const OFFICIAL_VENDOR_NAME = "NetEase Youdao";
export const OFFICIAL_REPO_URL = "https://github.com/netease-youdao/LobsterAI";
export const SUPPORT_EMAIL = "support@lobsterai.homes";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
